/**
 * Meta event names sent to pixel + CAPI (must match Everflow Partner → Meta postbacks).
 *
 * Everflow UI label → Meta event name:
 *   Start Quiz       → ViewContent
 *   Quiz Completed   → AddToCart
 *   First Purchase   → SubscriptionCreation
 *   Purchase         → Purchase
 */
export const META_EVENT_START_QUIZ = 'ViewContent'
export const META_EVENT_QUIZ_COMPLETED = 'AddToCart'
export const META_EVENT_FIRST_PURCHASE = 'SubscriptionCreation'
export const META_EVENT_PURCHASE = 'Purchase'
